export enum DocumentType {
  IDENTITY_PROOF = 'IDENTITY_PROOF',
  ADDRESS_PROOF = 'ADDRESS_PROOF',
}

export enum IdentityType {
  PASSPORT = 'PASSPORT',
  DRIVER_LICENSE = 'DRIVING_LICENSE',
  ID_CARD = 'ID_CARD',
  RESIDENT_PERMIT_ID = 'RESIDENT_PERMIT_ID',
}

export enum DocumentSide {
  FRONT = 'FRONT',
  BACK = 'BACK',
}

export interface Document {
  id: string;
  type: string;
  provider?: string;
  providerId?: string;
  status: string;
  refusedReasonMessage: string;
  creationDate?: Date;
  created?: Date;
  updated?: Date;
}

export interface KycDocument {
  id?: string;
  documentId: string;
  documentRef: string;
  documentSide: string;
  file?: File;
  identityType: string;
  provider?: string;
  providerId?: string;
  type?: string;
  status?: string;
  refusedMessage?: string;
  refusedType?: string;
  created?: Date;
  updated?: Date;
}
